import React from 'react';
import './styles.css'
const Link = ({ attributes, element, children}) => {
    return (
        <div className='link' >
            <a href={element.href} {...attributes} {...element.attr} target={element.target}>{children}</a>
        </div>
    )
}
export default Link